import { createFileRoute } from '@tanstack/react-router';

import { DesignOverviewPage } from '@/features/design/overview-page';

export const Route = createFileRoute('/_app/projects/$projectId/design/overview')({
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  return <DesignOverviewPage projectId={projectId} />;
}
